import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { NavigateFunction } from "react-router-dom";
import { useAuth } from "../../../../../providers";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { PaymentOrderResponse, PaymentStrings } from "../../../business";
import { PaymentOrdersPageControllerImpl } from "../../../business/impl";
import { PaymentOrdersPageFactoryImpl } from "../factories";

interface IPaymentOrdersPage {
    navigate: NavigateFunction,
}

export const PaymentOrdersPage: React.FC<IPaymentOrdersPage> = ({ navigate }) => {
    const strings = PaymentStrings['PTBR'].payment_order;
    const { setCallbackLogin, handleLogout } = useAuth();
    const [isLoading, setLoading] = useState<Boolean>(true);
    const [paymentOrdersData, setPaymentOrdersData] = useState<PaymentOrderResponse>({ success: true, response: [] });

    const factory = new PaymentOrdersPageFactoryImpl();
    const controller = new PaymentOrdersPageControllerImpl();

    const fetchData = async () => {
        try {
            const response = await controller.onLoad();
            setLoading(false);
            setPaymentOrdersData(response);
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/adm/paymentOrder',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                console.error("Erro na requisição:", error);
            }
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const content =
        <> <h4 className="mb-4">{strings.title}</h4>
            <Card>
                <Card.Body>
                    {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(paymentOrdersData)}
                </Card.Body>
            </Card>
        </>

    return <AdmPanelContainer children={content} />
}
